import React, {PureComponent} from "react"
import PropTypes from "prop-types"

import OnboardingService from "@irati/onboarding/services/onboarding"
import OnboardingStep from "@irati/onboarding/enums/Step"
import {hangPromise} from "@irati/utils/promise"
import Loading from "@irati/ui/src/Loading"
import {ReduxState} from "@irati/store/types"
import {connect} from "@irati/store"
import authentication from "@irati/auth"
import {LangLoader, FormattedMessage} from "@irati/utils/lang"
import Button from "@irati/ui/src/Button"
import {ButtonLink} from "@irati/ui/src/Link"
import Close from "@irati/ui/src/Close"
import {greys} from "@irati/ui/src/global/colors"
import Routes, {SETUP_TENANT} from "@irati-web/app/src/routeConfig"
import Flex from "@irati/ui/src/Flex"
import {Para} from "@irati/ui/src/Labels"
import tenantSetupTracking, {ClickedModalValues} from "@irati-tracking/tenant-setup"

import {Wrapper, Notification, CloseWrapper, CenterH1, WelcomeImage, ContentWrapper} from "./styled"

interface Props {
  isMobile: boolean
}
interface State {
  showNotification: boolean,
  load: Promise<any>
}

const LEGACY_TENANT_SETUP_HIDE_COOKIE = "hideTenantSetupPrompt"

class FullScreenNotification extends PureComponent<Props, State> {
  static contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
  }
  state: State = {
    showNotification: false,
    load: hangPromise()
  }

  componentDidMount = () => {
    const promises = [OnboardingService.getTenantOnboarding()]
    if (!authentication.isUserGhost()) {
      promises.push(OnboardingService.get(authentication.user().uuid))
    }
    const load = Promise.all(promises).then(([tenantOnboarding, userOnboarding]) => {

      // Moved from LocalStorage -> graph (Feb-2020), check kept to avoid double tours
      const seenModalPreviously = authentication.isUserGhost() ||
        userOnboarding.completedSteps.includes(OnboardingStep.HAS_VIEWED_TENANT_SETUP_PRE_TOUR)
      const modalViewable = tenantOnboarding?.enabled && !tenantOnboarding.onboardingFinished

      if (modalViewable && this.shouldShowNotification() && !seenModalPreviously) {
        // If the service thinks the user should see the tour but they have the LocalStorage value, fire an update
        if (localStorage.getItem(LEGACY_TENANT_SETUP_HIDE_COOKIE)) {
          this.neverShowWelcomeAgain()
        } else {
          tenantSetupTracking.viewSetupModal()
          this.setState({showNotification: true})
        }
      }
    })
    this.setState({load})
  }

  shouldShowNotification = () => {
    const {isMobile} = this.props
    const {apps, appPath} = this.context
    const isAdmin = authentication.isGlobalAdmin()
    const isHome = appPath === apps.HOME
    return isAdmin && !isMobile && isHome
  }

  neverShowWelcomeAgain = () => OnboardingService.completeStep(authentication.user(), OnboardingStep.HAS_VIEWED_TENANT_SETUP_PRE_TOUR)

  onHideNotification = (clickedElement: ClickedModalValues) => {
    this.setState({showNotification: false})
    this.neverShowWelcomeAgain()
    tenantSetupTracking.clickSetupModal({clicked: clickedElement})
  }

  render() {
    const {load, showNotification} = this.state

    if (!showNotification) {
      return null
    }

    return (
      <LangLoader bucket={SETUP_TENANT}>
        <Loading load={load}>
          <Wrapper>
            <Notification>
              <CloseWrapper>
                <Close onClick={() => this.onHideNotification(ClickedModalValues.Cross)} color={greys.mediumDark} top="20px" right="20px" />
              </CloseWrapper>
              <WelcomeImage />
              <ContentWrapper>
                <CenterH1 base>
                  <FormattedMessage id="setup_tenant.fullScreenModal.title.main" />
                </CenterH1>
                <Para large center>
                  <FormattedMessage id="setup_tenant.fullScreenModal.title.sub" />
                </Para>

                <Flex alignItems="center" justifyContent="space-around" margin="30px 0 0 0" width="100%">
                  <Button large onClick={() => this.onHideNotification(ClickedModalValues.Dolater)}>
                    <FormattedMessage id="setup_tenant.fullScreenModal.buttons.later" />
                  </Button>
                  <ButtonLink onClick={() => this.onHideNotification(ClickedModalValues.Letsgo)} large primary href={Routes[SETUP_TENANT]}>
                    <FormattedMessage id="setup_tenant.fullScreenModal.buttons.start" />
                  </ButtonLink>
                </Flex>
              </ContentWrapper>
            </Notification>
          </Wrapper>
        </Loading>
      </LangLoader>
    )
  }
}
const mapStateToProps = ({mq}: ReduxState) => ({isMobile: mq.lessThan.sm})

export default connect(mapStateToProps)(FullScreenNotification)
